<template>
  <div>
    <header></header>
    <h1 class="bit-right">Motion</h1>
    <div id="toolbar">
      <a :href="routeCreate" class="big-purple-button">Add video</a>
      <a v-if="!showreelMotion" :href="routeCreateShowreel" class="big-purple-button">Add showreel</a>
    </div>
    <div class="message-box warning-message">
      Note: The motion section is reserved for professional animators and motion designers.<br>
      Content that does not fulfill this criteria will be removed.
    </div>
    <div class="masonry-list">
      <div class="motions-wrapper sortable set-after custom-little-grid">

        <div v-if="showreelMotion" class="grid-item-wrapper unsortable">
          <div class="custom-grid-item showreel">
            <div class="custom-grid-item-preview">
              <a :href="routeShow.replace(':userName', illustrator.name).replace(':motionId', showreelMotion.id)">
                <img :src="getImageUrl(showreelMotion)" :alt="showreelMotion.title" data-rjs="2">
              </a>
              <div class="status-marker">Showreel</div>
            </div>
            <div class="custom-grid-item-info">
              <div>
                <a :href="routeEdit.replace(':id', showreelMotion.id)"
                   class="big-purple-button full-width align-center">Edit</a>
              </div>
              <button type="button"
                      class="btn-remove transparent-button full-width align-center no-padding-left no-padding-right"
                      @click="remove(showreelMotion)">Delete
              </button>
            </div>
          </div>
        </div>

        <div class="grid-item-wrapper sortable-item"
             :data-resource-weight="motion.weight"
             data-resource-type="motion"
             :data-resource-id="motion.id"
             v-for="motion in individualMotions" :key="motion.id">
          <div class="custom-grid-item">
            <div class="custom-grid-item-preview">
              <a :href="routeShow.replace(':userName', illustrator.name).replace(':motionId', motion.id)">
                <img :src="getImageUrl(motion)" :alt="motion.title" data-rjs="2">
              </a>
              <div class="drag-trigger"><i class="fa fa-arrows" aria-hidden="true"></i></div>
            </div>
            <div class="custom-grid-item-info">
              <div>
                <a :href="routeEdit.replace(':id', motion.id)"
                   class="big-purple-button full-width align-center">Edit</a>
              </div>
              <button type="button"
                      class="btn-remove transparent-button full-width align-center no-padding-left no-padding-right"
                      @click="remove(motion)">Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modal from './../../../services/modal';
import motionApi from './../../../api/motion';

export default {
  props: {
    routeCreate: {
      type: String,
    },

    routeEdit: {
      type: String,
    },

    routeShow: {
      type: String,
    },

    routeDelete: {
      type: String,
    },

    illustrator: {
      type: Object,
    },

    motions: {
      type: Array,
    },
  },

  data() {
    return {
      routeCreateShowreel: `${this.routeCreate}?type=showreel`,

      showreelMotion: null,

      individualMotions: [],
    };
  },

  created() {
    this.setShowreelMotion();

    this.setIndividualMotions();
  },

  methods: {
    setShowreelMotion() {
      this.showreelMotion = this.motions.filter((motion) => {
        return motion.type === 'showreel';
      })[0];
    },

    setIndividualMotions() {
      this.individualMotions = this.motions.filter((motion) => {
        return motion.type !== 'showreel';
      });
    },

    getImageUrl(motion) {
      return motion.imagePath;
    },

    getDefaultImageUrl() {
      return `${location.origin}/images/motions/540x540/default.png`;
    },

    remove(motion) {
      modal.confirmation({
        text: 'Are you sure you want to delete this video?'
      })
        .then((response) => {
          if (!response.value) return;

          motionApi
            .remove(this.routeDelete.replace(':id', motion.id))
            .then(() => {
              modal.success({title: 'Video successfully deleted'}).then(() => {
                location.reload();
              });
            });
        });
    }
  }
};
</script>

<style scoped>
  .btn-remove {
    margin-top: 10px;
  }

  .showreel {
    border: 5px solid;
    color: #6f1b57;
  }

  #toolbar {
    min-height: 30px;
  }
</style>
